import BaseApi from "@/core/HttpResources/BaseApi";

export default class AcademicTitleService {
  baseApiPublish = new BaseApi("AcademicTitle");
  async getAcademicTitle(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}